var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1201_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60776 13.9668C5.79296 14.0459 6.00829 13.9798 6.11646 13.809L11.0383 5.98866C11.118 5.86208 11.1229 5.70226 11.0508 5.57169C10.9786 5.44071 10.8409 5.35939 10.6915 5.35939H7.40659L8.62826 0.511102C8.67753 0.315239 8.57778 0.11295 8.39234 0.0332428C8.20809 -0.0460541 7.99139 0.0204186 7.88363 0.191044L2.96176 8.01135C2.88205 8.13793 2.87724 8.29775 2.94934 8.42832C3.02145 8.5593 3.15923 8.64062 3.30864 8.64062H6.5935L5.37184 13.4889C5.32256 13.6848 5.42228 13.8871 5.60776 13.9668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1201_1115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastest);
export default __webpack_public_path__ + "static/media/fastest.75bac08300c7bb9c24c6597623b5d5cb.svg";
export { ForwardRef as ReactComponent };